export const filledStyleAttributes = ["title", "detailedTitle", "price", "productType"];
